var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--bottom_banner position-relative bottom-banner-image-ratio box-rounded-big shadowed overflow-hidden"
  }, [_c('div', {
    staticClass: "centered-xy w-100 h-100"
  }, [_c('nuxt-img', {
    staticClass: "centered-xy md:tw-w-full",
    attrs: {
      "src": _vm.imageUrl,
      "alt": "",
      "width": "1120",
      "height": "408",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _vm.$slots.default ? [_c('div', {
    staticClass: "centered-xy w-100"
  }, [_vm._t("default")], 2)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }